import { observer } from "mobx-react";
import * as React from "react";
import { Badge, Button } from "react-bootstrap";

import "../assets/scss/ButtonAndBadge.scss";

export interface ButtonAndBadgeProps {
  isActive: boolean;
  text: string;
  count: number;
}

@observer
export class ButtonAndBadge extends React.Component<
  ButtonAndBadgeProps,
  undefined
> {
  render() {
    return (
      <div className="buttonAndBadge">
        <Button
          bsSize="large"
          block
          bsStyle={this.props.isActive ? "primary" : undefined}
        >
          {this.props.text}
        </Button>
        <Badge className="wordCount">{this.props.count}</Badge>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/ButtonAndBadge.tsx